"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TomatoCardItem = void 0;
var React = require("react");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var Image_1 = require("../../../../common/Image");
var DiscountInfoCard_1 = require("../Components/DiscountInfoCard");
var NameViews_1 = require("../Components/NameViews");
var PriceViews_1 = require("../Components/PriceViews");
var StarsAndSold_1 = require("../Components/StarsAndSold");
var TwentyFour_1 = require("../Components/TwentyFour");
var styles_1 = require("./styles");
var utils_1 = require("../utils");
exports.TomatoCardItem = function (props) {
    var product = props.product, imgWidth = props.imgWidth, imgHeight = props.imgHeight, customUI = props.customUI, prm = props.prm, spm = props.spm, placeholderBg = props.placeholderBg;
    var _a = utils_1.transformProduct(product, customUI, prm, spm), _b = _a.img, img = _b === void 0 ? "" : _b, _c = _a.name, name = _c === void 0 ? "" : _c, _d = _a.price, price = _d === void 0 ? "" : _d, _e = _a.originPrice, originPrice = _e === void 0 ? "" : _e, extra = _a.extra;
    var _f = extra, _g = _f.ltImg, ltImg = _g === void 0 ? "" : _g, _h = _f.rtImg, rtImg = _h === void 0 ? "" : _h, _j = _f.sold, sold = _j === void 0 ? "" : _j, _k = _f.star, star = _k === void 0 ? 0 : _k, _l = _f.titleImg, titleImg = _l === void 0 ? "" : _l, _m = _f.twentyTour, twentyTour = _m === void 0 ? "" : _m, countdownToEnd = _f.countdownToEnd;
    return (React.createElement(styles_1.ProductCard, { target: "_blank", imgWidth: imgWidth, href: product.url },
        React.createElement(styles_1.ProductCardPoster, null,
            React.createElement(Image_1.default, { key: img, defaultSrc: placeholderBg, src: smartimagesrc_1.makeImageUrls(img, {
                    online: true
                })[0], style: {
                    width: imgWidth + "px",
                    height: imgHeight + "px"
                }, params: "imageView2/2/w/300" }),
            React.createElement(DiscountInfoCard_1.DiscountInfoCard, { ltImg: ltImg, rtImg: rtImg, countdownToEnd: countdownToEnd })),
        React.createElement(styles_1.DescriptionWrap, null,
            React.createElement(NameViews_1.NameViews, { name: name, activeImg: titleImg }),
            React.createElement(PriceViews_1.PriceViews, { price: price, originPrice: originPrice }),
            React.createElement(StarsAndSold_1.StarsAndSold, { sold: sold, star: star }),
            React.createElement(TwentyFour_1.TwentyFour, { text: twentyTour }))));
};
